const app = {
  state: {
    cachedViews: [],
    isMobile: false,
    headerShow: true,
    defaultImg: 'this.src="' + require('@assets/images/error.png') + '"', // 默认图片
    defaultHeadImg:
      'this.src="' + require('@assets/images/default-head.svg') + '"', // 默认头像
    breadcumbList: {},  // 动态修改面包屑数据
    breadStyleType: '',  // 动态修改面包屑样式  ''白色文字 1黑色文字 2灰色背景
  },
  mutations: {
    TOGGLE_HEADER: (state, isShow) => {
      state.headerShow = isShow
    },

    ADD_CACHED_VIEW: (state, view) => {
      if (state.cachedViews.includes(view.name)) return
      state.cachedViews.push(view.name)
    },

    DEL_CACHED_VIEW: (state, view) => {
      const index = state.cachedViews.indexOf(view.name)
      index > -1 && state.cachedViews.splice(index, 1)
      console.log('-------------', state)
    },

    SET_BREAD: (state, data) => {
      console.log('-----------------')
      state.breadcumbList = data
    },
    SET_BREAD_TYPE: (state, data) => {
      state.breadStyleType = data

      console.log(99, state.breadStyleType)
    },
  },
  actions: {
    ToggleHeader({ commit }, isShow) {
      commit('TOGGLE_HEADER', isShow)
    },

    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },
    delCachedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },

    
    // 改变面包屑
    changeBread({ commit }, data) {
      commit('SET_BREAD', data)
      // state.breadcumbList = data
    },
    changeBreadStyleType({ commit }, data) {
      commit('SET_BREAD_TYPE', data)
    }
  }
}

export default app
